export { authApi } from './services/auth.api';
export { authKeys } from './services/auth.queries';
export {
  useLoginMutation,
  useVerifyLoginOtpMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation
} from './services/auth.mutations';
export { AuthGuard } from './components/auth-guard';
export { GuestGuard } from './components/guest-guard';
export type {
  AuthUser,
  AuthStatus,
  LoginRequest,
  LoginResponse,
  LoginOtpRequiredResponse,
  VerifyLoginOtpRequest,
  VerifyLoginOtpResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest
} from './types';
export { isOtpRequired } from './types';
export {
  isSuperAdmin,
  hasRole,
  hasAnyRole,
  hasPermission,
  hasAnyPermission,
  hasAllPermissions
} from './utils/permissions';
export { PermissionGate } from './components/permission-gate';
export { PasswordStrengthIndicator } from './components/password-strength-indicator';
export {
  REDIRECT_QUERY_PARAM,
  REDIRECT_FALLBACK,
  sanitizeRedirectPath,
  capturePendingRedirect,
  consumePendingRedirect,
  clearPendingRedirect,
  markExplicitLogout
} from './utils/redirect';
export { canAccessRoute } from './utils/route-access';
